import PhotoGridViewerFooterButton from './PhotoGridViewerFooterButton';

export default PhotoGridViewerFooterButton;
